/* eslint-disable no-mixed-operators */
import { Link, useNavigate } from "react-router-dom";
import 'bootstrap/dist/css/bootstrap.min.css';
import "../../assets/scss/pages/profile.scss";
import { menuList } from "./contents";
import React, { useEffect, useState } from "react";
import { Form } from "react-bootstrap";
import useAuth from "../../hooks/useAuth";
import { DefaultButton, RoundedInput } from "../../components/widgets";
import GoogleMapReact from 'google-map-react';
import { getClientList, getIpAddress, getMoods, getUserInfo } from "../../actions/user";
import { GOOGLE_MAP_KEY } from "../../constants";
import { setAddress } from "../../utils/geocode";
import Geocode from "react-geocode";
import { setUserInfo } from "../../actions/user";
import { toast } from "react-toastify";
import { planList } from "../membership/contents";
import { PageHeader } from "../../components";
import { friendlyDateTime, onKeyDownForm } from "../../utils";
import Autocomplete from 'react-google-autocomplete';
import CreatableSelect from "react-select/creatable";
import { setSession } from "../../contexts/JWTAuthContext";
import { Genre } from "../../actions";
import { Backend } from "shared-types";

interface markerType {
    lat: number;
    lng: number;
};

export const ProfilePage: React.FC = () => {
    const navigate = useNavigate();
    const { user, dispatchUser } = useAuth() as any;
    const [active, setActive] = useState(menuList[0].key);
    const [genreList, setGenreList] = useState<Backend.T_Genre[]>([]);
    const [moodList, setMoodList] = useState<Backend.T_Mood[]>([]);
    const [showMap, setShowMap] = useState(false);
    const [validated, setValidated] = useState(false);
    const [compvalidated, setCompValidated] = useState(false);
    const [passvalidated, setPassValidated] = useState(false);
    const Marker = (props: markerType) => <div>
        <svg style={{ marginLeft: '-18px', marginTop: '-50px' }} width="36px" height="36px" viewBox="-4 0 36 36" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">
            <title>map-marker</title>
            <desc>Created with Sketch.</desc>
            <defs></defs>
            <g id="Vivid.JS" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                <g id="Vivid-Icons" transform="translate(-125.000000, -643.000000)">
                    <g id="Icons" transform="translate(37.000000, 169.000000)">
                        <g id="map-marker" transform="translate(78.000000, 468.000000)">
                            <g transform="translate(10.000000, 6.000000)">
                                <path d="M14,0 C21.732,0 28,5.641 28,12.6 C28,23.963 14,36 14,36 C14,36 0,24.064 0,12.6 C0,5.641 6.268,0 14,0 Z" id="Shape" fill="red"></path>
                                <circle id="Oval" fill="#0C0058" fillRule="nonzero" cx="14" cy="14" r="7"></circle>
                            </g>
                        </g>
                    </g>
                </g>
            </g>
        </svg>
    </div>;
    const [ip, setIp] = useState("");
    const [clientList, setClientList] = useState<any>([]);
    const [formData, setFormData] = useState<any>({
        first_name: "",
        last_name: "",
        username: "",
        email: "",
        mobile_number: "",
        country: "",
        address: "",
        client: {
            id: -1,
            title: "",
            url: "",
            tel: "",
            email: "",
        },
        favorites: {
            genre: [],
            mood: [],
            activity: [],
            season: [],
        },
        current_password: "",
        new_password: "",
        confirm_password: "",
    });
    const [location, setLocation] = useState({ lat: 52.5200, lng: 13.4050 });
    const [zoom, setZoom] = useState(4);
    const [loading, setLoading] = useState(false);
    const [loadingComp, setLoadingComp] = useState(false);
    const [profileGeneralStatus, setProfileGeneralStatus] = useState<boolean>(false);
    const [profileClientStatus, setProfileClientStatus] = useState<boolean>(false);
    // const [searchGenre, setSearchGenre] = useState("");
    const [timer, setTimer] = useState<any>();

    useEffect(() => {
        getIpAddress().then((res) => setIp(res)).catch(console.warn);
    }, []);

    const loadUserInfo = async () => {
        formData.first_name = user.profile.first_name ? user.profile.first_name : "";
        formData.last_name = user.profile.last_name ? user.profile.last_name : "";
        formData.username = user.account;
        formData.email = user.email;
        formData.mobile_number = user.tel ? user.tel : "";
        formData.company_name = user.company ? user.company : "";
        formData.contactor_number = user.profile.business_number ? user.profile.business_number : "";
        setLocation({ lat: user.geo_info.lat, lng: user.geo_info.lon });
        setZoom(8);
        formData.country = user.geo_info.country;
        formData.address = user.geo_info.address;

        let dataGenre = await Genre.all();
        let favorites = formData.favorites;
        setGenreList(dataGenre);
        if (user.profile.favorite_genres !== "") {
            favorites.genre = user.profile.favorite_genres.split(',')?.map((m: string) => Number(m));
        }

        let dataMood = await getMoods();
        setMoodList(dataMood);
        if (user.profile.favorite_moods !== "") {
            favorites.mood = user.profile.favorite_moods.split(',')?.map((m: string) => Number(m));
        }

        if (user.profile.favorite_activities !== "") {
            favorites.activity = user.profile.favorite_activities.split(',');
        }
        if (user.profile.favorite_seasons !== "") {
            favorites.season = user.profile.favorite_seasons.split(',');
        }

        let client = clientList.filter((c: any) => c.id === user.client.id);
        if (!clientList.length) {
            let dataClient = await getClientList({});
            setClientList(dataClient.result);
            client = dataClient.result.filter((c: any) => c.id === user.client.id);
        }
        if (client.length) client = client[0];
        else client = formData.client;

        setFormData({
            ...formData,
            favorites: favorites,
            client: {
                id: Number(client.id),
                title: client.title,
                email: client.email,
                tel: client.tel,
                url: client.url,
            },
        });
    };

    useEffect(() => {
        setTimeout(() => {
            setShowMap(true);
        }, 1000);
        if (user && user.profile) {
            loadUserInfo();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [user]);

    const handlePersonalInformationSubmit = async (event: { currentTarget: any; preventDefault: () => void; stopPropagation: () => void; }) => {
        const form = event.currentTarget;
        event.preventDefault();
        if (form.checkValidity() === false) {
            event.stopPropagation();
            setValidated(false);
        } else {
            setValidated(true);
            setLoading(true);
            await setUserInfo({
                is_profile: true,
                first_name: formData.first_name,
                last_name: formData.last_name,
            });
            await setUserInfo({
                name: formData.first_name + (formData.last_name === '' ? '' : ' ') + formData.last_name,
                email: formData.email,
                tel: formData.mobile_number,
            });
            setLoading(false);
            setProfileGeneralStatus(false);
            setTimeout(() => {
                toast("successful saved!");
            }, 200);
        }
    };

    const handleCompanySubmit = async (event: { currentTarget: any; preventDefault: () => void; stopPropagation: () => void; }) => {
        const form = event.currentTarget;
        event.preventDefault();
        if (form.checkValidity() === false) {
            event.stopPropagation();
            setCompValidated(false);
        } else {
            setCompValidated(true);
            setLoadingComp(true);
            const response = await setUserInfo({
                ...formData.client,
                ip: ip,
                is_client: true,
            });
            if (response.token) setSession(response.token);
            let data = await getClientList({});
            setClientList(data.result);
            getUserInfo().then((response) => {
                dispatchUser(response.data.userInfo);
                setLoadingComp(false);

                setActive(menuList[1].key);
                setProfileClientStatus(false);
                setTimeout(() => {
                    toast("successful saved!");
                }, 200);
            }).catch(console.warn);
        }
    }

    const handleFavoritesSubmit = async (event: { currentTarget: any; preventDefault: () => void; stopPropagation: () => void; }) => {
        event.preventDefault();
        // setLoading(true);
        // await setUserInfo({
        //     is_profile: true,
        //     favorite_genres: formData.favorites.genre,
        //     favorite_moods: formData.favorites.mood,
        //     favorite_activities: formData.favorites.activity,
        //     favorite_seasons: formData.favorites.season,
        // });
        // setLoading(false);
        // setTimeout(() => {
        //     toast("successful saved!");
        // }, 200);
    };

    const handleGenre = async (genre: number) => {
        let list = [];
        formData.favorites.genre.forEach((g: any) => {
            if (genre !== g) list.push(g);
        });
        if (!formData.favorites.genre.filter((g: any) => g === genre).length) {
            list.push(genre);
        }
        let favorites = formData.favorites;
        favorites.genre = list;
        setFormData({ ...formData, favorites: favorites });

        await setUserInfo({
            is_profile: true,
            favorite_genres: list,
            favorite_moods: formData.favorites.mood,
            favorite_activities: formData.favorites.activity,
            favorite_seasons: formData.favorites.season,
        });
    };

    const handleMood = async (mood: number) => {
        let list = [];
        formData.favorites.mood.forEach((g: any) => {
            if (mood !== g) list.push(g);
        });
        if (!formData.favorites.mood.filter((g: any) => g === mood).length) {
            list.push(mood);
        }
        let favorites = formData.favorites;
        favorites.mood = list;
        setFormData({ ...formData, favorites: favorites });

        await setUserInfo({
            is_profile: true,
            favorite_genres: formData.favorites.genre,
            favorite_moods: list,
            favorite_activities: formData.favorites.activity,
            favorite_seasons: formData.favorites.season,
        });
    };

    const setLocationAction = (e: any) => {
        clearTimeout(timer);
        setTimer(setTimeout(
            () => {
                handleLocation(e);
            }, 700
        ));
    };

    const handleLocation = async (e: any) => {
        if (e.lat && e.lng) {
            Geocode.setApiKey(GOOGLE_MAP_KEY);
            Geocode.setLanguage("en");
            Geocode.fromLatLng(e.lat.toString(), e.lng.toString()).then(
                (response) => {
                    let country = "", address = response.results[0].formatted_address;
                    for (let i = 0; i < response.results[0].address_components.length; i++) {
                        for (let j = 0; j < response.results[0].address_components[i].types.length; j++) {
                            switch (response.results[0].address_components[i].types[j]) {
                                case "country":
                                    country = response.results[0].address_components[i].long_name;
                                    break;
                            }
                        }
                    }
                    setFormData({ ...formData, country: country, address: address });
                    setLocation({
                        lat: response.results[0].geometry.location.lat,
                        lng: response.results[0].geometry.location.lng
                    });
                },
                (error) => {
                    console.error(error);
                }
            );
            await setAddress(e.lat, e.lng);
            await getUserInfo().then((response) => {
                dispatchUser(response.data.userInfo);
            }).catch(console.warn);
        }
    };

    const handlePassword = async (event: { currentTarget: any; preventDefault: () => void; stopPropagation: () => void; }) => {
        const form = event.currentTarget;
        event.preventDefault();
        if (form.checkValidity() === false) {
            event.stopPropagation();
            setPassValidated(true);
        } else {
            setPassValidated(false);
            if (formData.new_password !== formData.confirm_password) {
                setTimeout(() => {
                    toast("No match new password and confirm password!");
                }, 200);
                formData.new_password = "";
                formData.confirm_password = "";
                setFormData({
                    ...formData,
                    new_password: "",
                    confirm_password: "",
                });
                return;
            }
            setLoading(true);
            await setUserInfo({
                is_password: true,
                password: formData.new_password,
            }).then((data) => {
                if (data.result.code === -20000) {
                    setTimeout(() => {
                        toast(data.result.message);
                    }, 200);
                    setFormData({
                        ...formData,
                        new_password: "",
                        confirm_password: "",
                    });
                } else {
                    setActive(menuList[4].key);
                    setTimeout(() => {
                        toast("successful saved!");
                    }, 200);
                }
            });
            setLoading(false);
        }
    };

    const handleMembership = () => {
        navigate("/membership");
    };

    return (
        <div className="page page-profile">
            <PageHeader title="MY PROFILE" withoutBottomPadding={true}>
                <ul className={"tab-nav"} style={{ paddingLeft: "0" }}>
                    {menuList?.map((menu, index) => (
                        <li
                            key={index}
                            className={`nav-item ${(menu.key === active ? 'active' : '')}`}
                            onClick={() => setActive(menu.key)}
                        >
                            <Link to={""}>{menu.text}</Link>
                        </li>
                    ))}
                </ul>
            </PageHeader>
            <div className="content-wrapper tab-content">
                {active === menuList[0].key ? (
                    <>
                        <Form
                            noValidate
                            className='pt-3'
                            validated={validated}
                            onSubmit={handlePersonalInformationSubmit}
                            onKeyDown={onKeyDownForm}
                        >
                            <div className="bg-blue general-tab">
                                <div className="container uk-container-large" style={{ minHeight: 'unset' }}>
                                    <div className="row">
                                        <Form.Label className="col-md-12">
                                            <h3>General</h3>
                                        </Form.Label>
                                        <Form.Group className={"col-md-4" + (formData.username === "" ? " error" : "")}>
                                            <div className="input-label">username</div>
                                            <RoundedInput
                                                required
                                                disabled
                                                type="text"
                                                placeholder=""
                                                value={formData.username}
                                                onChange={(e) => setFormData({ ...formData, username: e.target.value })}
                                            />
                                            <Form.Control.Feedback type="invalid">
                                                Uusername can not empty.
                                            </Form.Control.Feedback>
                                        </Form.Group>
                                        <Form.Group className={"col-md-4"}>
                                            <div className="input-label">first name</div>
                                            <RoundedInput
                                                type="text"
                                                value={formData.first_name}
                                                placeholder={""}
                                                onChange={(e) => {
                                                    setProfileGeneralStatus(true);
                                                    setFormData({ ...formData, first_name: e.target.value });
                                                }}
                                            />
                                        </Form.Group>
                                        <Form.Group className={"col-md-4"}>
                                            <div className="input-label">last name</div>
                                            <RoundedInput
                                                type="text"
                                                value={formData.last_name}
                                                placeholder={""}
                                                onChange={(e) => {
                                                    setProfileGeneralStatus(true);;
                                                    setFormData({ ...formData, last_name: e.currentTarget.value });
                                                }}
                                            />
                                        </Form.Group>
                                        <Form.Group className={"col-md-4" + (formData.email === "" ? " error" : "")}>
                                            <div className="input-label">email</div>
                                            <RoundedInput
                                                required
                                                type="text"
                                                placeholder=""
                                                value={formData.email}
                                                onChange={(e) => {
                                                    setProfileGeneralStatus(true);
                                                    setFormData({ ...formData, email: e.target.value });
                                                }}
                                            />
                                            <Form.Control.Feedback type="invalid">
                                                Email can not empty.
                                            </Form.Control.Feedback>
                                        </Form.Group>
                                        <Form.Group className={"col-md-4"}>
                                            <div className="input-label">mobile number</div>
                                            <RoundedInput
                                                type="text"
                                                placeholder=""
                                                value={formData.mobile_number}
                                                onChange={(e) => {
                                                    setProfileGeneralStatus(true);
                                                    setFormData({ ...formData, mobile_number: e.target.value });
                                                }}
                                            />
                                        </Form.Group>
                                        {profileGeneralStatus && (
                                            <div className='col-md-4 d-flex justify-content-end align-items-end'>
                                                <DefaultButton type="submit" loading={loading}>Save</DefaultButton>
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </Form>
                        {user?.profile?.membership_level > 1 && (
                            <Form
                                noValidate
                                className='pt-3'
                                validated={compvalidated}
                                onSubmit={handleCompanySubmit}
                                onKeyDown={onKeyDownForm}
                            >
                                <div className="bg-white company-tab">
                                    <div className="container uk-container-large" style={{ minHeight: 'unset' }}>
                                        <div className="row">
                                            <Form.Label className="col-md-4 -title">
                                                <h3>Company</h3>
                                            </Form.Label>
                                            <div className="col-md-8 -content">
                                                {clientList && clientList.length ? (
                                                    <CreatableSelect
                                                        className=""
                                                        isClearable
                                                        options={clientList?.map((c: any) => ({
                                                            value: c.id,
                                                            label: c.title
                                                        }))}
                                                        onChange={(v: any) => {
                                                            if (v === null) {
                                                                setFormData({
                                                                    ...formData,
                                                                    client: {
                                                                        id: -1,
                                                                        title: "",
                                                                        url: "",
                                                                        tel: "",
                                                                        email: "",
                                                                    }
                                                                });
                                                            } else {
                                                                var client = clientList.filter((c: any) => c.id === v.value);
                                                                if (client.length) client = client[0];
                                                                setFormData({
                                                                    ...formData,
                                                                    client: {
                                                                        id: Number(client.id),
                                                                        title: client.title,
                                                                        url: client.url,
                                                                        tel: client.tel,
                                                                        email: client.email,
                                                                    }
                                                                });
                                                            }
                                                            setProfileClientStatus(true);
                                                        }}
                                                        onCreateOption={(v: string) =>
                                                            setFormData({
                                                                ...formData,
                                                                client: {
                                                                    id: -1,
                                                                    title: v,
                                                                    url: "",
                                                                    tel: "",
                                                                    email: "",
                                                                }
                                                            })
                                                        }
                                                        value={{
                                                            value: formData.client.id,
                                                            label: formData.client.title,
                                                        }}
                                                    />
                                                ) : (<></>)}
                                                {/* (<LoadingWidget />)} */}
                                            </div>
                                            <Form.Group className={"col-md-4"}>
                                                <div className="input-label">email</div>
                                                <RoundedInput
                                                    type="text"
                                                    placeholder=""
                                                    value={formData.client.email ? formData.client.email : ''}
                                                    onChange={(e) => {
                                                        setFormData({
                                                            ...formData,
                                                            client: {
                                                                ...formData.client,
                                                                email: e.currentTarget.value,
                                                            }
                                                        });
                                                        setProfileClientStatus(true);
                                                    }}
                                                />
                                            </Form.Group>

                                            <Form.Group className={"col-md-4"}>
                                                <div className="input-label">mobile number</div>
                                                <RoundedInput
                                                    type="text"
                                                    placeholder=""
                                                    value={formData.client.tel ? formData.client.tel : ''}
                                                    onChange={(e) => {
                                                        setFormData({
                                                            ...formData,
                                                            client: {
                                                                ...formData.client,
                                                                tel: e.currentTarget.value,
                                                            }
                                                        });
                                                        setProfileClientStatus(true);
                                                    }}
                                                />
                                            </Form.Group>

                                            <Form.Group className={"col-md-4"}>
                                                <div className="input-label">website</div>
                                                <RoundedInput
                                                    type="text"
                                                    value={formData.client.url ? formData.client.url : ''}
                                                    placeholder={""}
                                                    onChange={(e) => {
                                                        setFormData({
                                                            ...formData,
                                                            client: {
                                                                ...formData.client,
                                                                url: e.currentTarget.value,
                                                            }
                                                        });
                                                        setProfileClientStatus(true);
                                                    }}
                                                />
                                            </Form.Group>

                                            {(formData.client.id === -1 && formData.client.title !== '' || formData.client.id !== -1) && profileClientStatus && (
                                                <div className='col-md-12 d-flex justify-content-end align-item-end -button'>
                                                    <DefaultButton type="submit" loading={loadingComp}>Save</DefaultButton>
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </Form>
                        )}
                        <div className={(user?.profile?.membership_level > 1 ? "bg-blue" : "bg-white") + " location-tab"}>
                            <div className="container uk-container-large" style={{ minHeight: 'unset' }}>
                                <div className="row">
                                    <Form.Label className="d-flex justify-content-left col-md-4 -title">
                                        <h3>Location</h3>
                                    </Form.Label>
                                    <Form.Group className="col-md-8 -content">
                                        <Autocomplete
                                            apiKey={GOOGLE_MAP_KEY}
                                            onPlaceSelected={(place: any) => {
                                                setLocation({
                                                    lat: place.geometry.location.lat(),
                                                    lng: place.geometry.location.lng()
                                                });
                                                setLocationAction({
                                                    lat: place.geometry.location.lat(),
                                                    lng: place.geometry.location.lng()
                                                });
                                            }}
                                            className="w-100 rounded-input op-input"
                                            defaultValue={formData.address}
                                        />
                                    </Form.Group>
                                    {showMap && (
                                        <div className="col-md-12 -map" style={{ height: '550px', width: '100%' }}>
                                            <GoogleMapReact
                                                bootstrapURLKeys={{ key: GOOGLE_MAP_KEY }}
                                                center={location}
                                                defaultCenter={location}
                                                zoom={zoom}
                                                onClick={(e) => {
                                                    setLocation(e);
                                                    setLocationAction(e);
                                                }}
                                                onChange={(e) => {
                                                    //console.log(["changed",e.center])
                                                    // setLocation(e.center);
                                                    // setLocationAction(e.center);
                                                }}
                                            >
                                                <Marker
                                                    lat={location.lat}
                                                    lng={location.lng}
                                                />
                                            </GoogleMapReact>
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>
                    </>
                ) : active === menuList[1].key ? (
                    <Form
                        noValidate
                        className='mt-3'
                        onSubmit={handleFavoritesSubmit}
                    >
                        <div className="bg-blue genre-tab">
                            <div className="container uk-container-large" style={{ minHeight: 'unset' }}>
                                <div className="row">
                                    <Form.Label className="col-md-12">
                                        <h3>Genres</h3>
                                    </Form.Label>
                                    <div className="col-md-12">
                                        <div className="mb-4 d-flex flex-wrap">
                                            {genreList?.map((genre) => (
                                                formData.favorites.genre.filter((g: any) => g === genre.id).length ? (
                                                    <DefaultButton
                                                        color="var(--color-blue-light)"
                                                        textColor="var(--color-blue-light-bg)"
                                                        borderColor="var(--color-blue-light)"
                                                        className="mb-3 me-3"
                                                        key={'genre_' + genre.id}
                                                        onClick={() => handleGenre(genre.id)}
                                                    >
                                                        {genre.title}
                                                    </DefaultButton>
                                                ) : genre.level === 1 ? (
                                                    <DefaultButton
                                                        color="var(--color-blue-light-bg)"
                                                        textColor="var(--color-blue-light)"
                                                        borderColor="var(--color-blue-light)"
                                                        className="mb-3 me-3"
                                                        key={'genre_' + genre.id}
                                                        onClick={() => handleGenre(genre.id)}
                                                    >
                                                        {genre.title}
                                                    </DefaultButton>
                                                ) : (
                                                    <></>
                                                )
                                            ))}
                                            {/* {formData.favorites.genre.filter((g) =>
                                                genreList.filter((_g) => g === _g.id && _g.level === 1).length
                                            ).length > 0 && (
                                                    <AutoComplete
                                                        items={genreList.filter((g) => {
                                                            if (g.level === 2) {
                                                                let parents = genreList.filter(
                                                                    (_g) => _g.level === 1 &&
                                                                        formData.favorites.genre.filter((__g) => __g === _g.id).length
                                                                );
                                                                if (parents.length && parents.filter((p) => p.id === g.parent_id).length > 0) {
                                                                    return true;
                                                                }
                                                            }
                                                            return false;
                                                        })}
                                                        itemKeyProperty={"id"}
                                                        itemLabelProperty={"title"}
                                                        value={searchGenre}
                                                        onChange={setSearchGenre}
                                                        width="200px"
                                                        borderColor="var(--color-blue-light)"
                                                    />
                                                )} */}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="bg-white mood-tab">
                            <div className="container uk-container-large" style={{ minHeight: 'unset' }}>
                                <div className="row">
                                    <Form.Label className="col-md-12">
                                        <h3>Moods</h3>
                                    </Form.Label>
                                    <div className="col-md-12">
                                        {moodList?.map((mood) => (
                                            formData.favorites.mood.filter((g: any) => g === mood.id).length ? (
                                                <DefaultButton
                                                    color="var(--color-blue-light)"
                                                    textColor="white"
                                                    borderColor="var(--color-blue-light)"
                                                    className="mb-3 me-3"
                                                    key={'mood_' + mood.id}
                                                    onClick={() => handleMood(mood.id)}
                                                >
                                                    {mood.title}
                                                </DefaultButton>
                                            ) : (
                                                <DefaultButton
                                                    color="white"
                                                    textColor="var(--color-blue-light)"
                                                    borderColor="var(--color-blue-light)"
                                                    className="mb-3 me-3"
                                                    key={'mood_' + mood.id}
                                                    onClick={() => handleMood(mood.id)}
                                                >
                                                    {mood.title}
                                                </DefaultButton>
                                            )
                                        ))}
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="container uk-container-large mb-3 mt-5" style={{ minHeight: "unset" }}>
                            <div className='d-flex justify-content-end'>
                                <DefaultButton onClick={() => setActive(menuList[2].key)}>Next</DefaultButton>
                            </div>
                        </div>
                    </Form>
                ) : active === menuList[2].key ? (//password
                    <Form
                        noValidate
                        className='mt-3'
                        validated={passvalidated}
                        onSubmit={handlePassword}
                    >
                        <div className="bg-blue password-tab">
                            <div className="container uk-container-large" style={{ minHeight: 'unset' }}>
                                <div className="row">
                                    <Form.Group className={"col-md-4" + (passvalidated && formData.current_password === "" ? " error" : "")}>
                                        <div className="input-label">Current Password</div>
                                        <RoundedInput
                                            required
                                            type="password"
                                            value={formData.current_password}
                                            onChange={(e) => setFormData({ ...formData, current_password: e.target.value })}
                                        />
                                        <Form.Control.Feedback type="invalid">
                                            Please fill out current password.
                                        </Form.Control.Feedback>
                                    </Form.Group>

                                    <Form.Group className={"col-md-4" + (passvalidated && formData.new_password === "" ? " error" : "")}>
                                        <div className="input-label">New Password</div>
                                        <RoundedInput
                                            required
                                            type="password"
                                            value={formData.new_password}
                                            onChange={(e) => setFormData({ ...formData, new_password: e.target.value })}
                                        />
                                        <Form.Control.Feedback type="invalid">
                                            Please fill out new password.
                                        </Form.Control.Feedback>
                                    </Form.Group>

                                    <Form.Group className={"col-md-4" + (passvalidated && formData.confirm_password === "" ? " error" : "")}>
                                        <div className="input-label">Confirm Password</div>
                                        <RoundedInput
                                            required
                                            type="password"
                                            value={formData.confirm_password}
                                            onChange={(e) => setFormData({ ...formData, confirm_password: e.target.value })}
                                        />
                                        <Form.Control.Feedback type="invalid">
                                            Please fill out confirm password.
                                        </Form.Control.Feedback>
                                    </Form.Group>
                                </div>
                                <div className='d-flex justify-content-end col-md-12 -button'>
                                    <DefaultButton className="me-4" onClick={() => setActive(menuList[4].key)}>Next</DefaultButton>
                                    <DefaultButton type="submit" loading={loading}>Save</DefaultButton>
                                </div>
                            </div>
                        </div>
                    </Form>
                ) : active === menuList[3].key ? (//notifications
                    <div className="bg-blue py-4">
                        <div className="container uk-container-large" style={{ minHeight: 'unset' }}>
                            {
                                user?.notifications?.map((item: any, index: number) => (
                                    <li key={index} className="notification-item">{item.msg} <span>{friendlyDateTime(item.created_at)}</span></li>
                                ))
                            }
                        </div>
                    </div>
                ) : active === menuList[4].key ? (//membership
                    <div className="bg-blue">
                        <div className="container uk-container-large" style={{ minHeight: 'unset' }}>
                            <div>
                                <p style={{ color: 'var(--color-blue-medium)', fontSize: '16px' }}>
                                    Your current plan is <span style={{ fontWeight: 'bold', fontSize: '18px' }}>{planList[user.profile.membership_level ? user.profile.membership_level : 0].title}</span>
                                    <span className="ms-2">and will expire on </span>
                                    {user.profile.membership_expire && (<span style={{}}>{friendlyDateTime(user.profile.membership_expire)}.</span>)}
                                </p>
                                {user.profile.membership_level < planList.length - 1 && (<DefaultButton onClick={handleMembership}>Upgrade your plan</DefaultButton>)}
                            </div>
                        </div>
                    </div>
                ) : (
                    <></>
                )
                }
            </div >
        </div >
    );
};